<template lang="pug">
  div
</template>
<script>
import { getVipStatus } from '@/api/vip';
import { env, Native } from '@hb/NBridge/lib/h5';
import config from '@/const/config';
import { getTokenAndKey } from '../../utils';

export default {
  async mounted() {
    let link = `https://m.hellobike.com/AppPlatformH5/${
      config.env !== 'pro' ? `${config.env}/` : ''
    }latest/pr_index_vip.html#/vip/open`;
    const isLogin = await Native.isLogin();
    if (!isLogin && env.isEasyBikeApp) {
      await getTokenAndKey();
      return;
    }
    if (isLogin) {
      const { token } = await getTokenAndKey();
      const openVip = await getVipStatus({ token })
        .then((res) => {
          if (res && res.data && res.data.openVip) {
            return true;
          }
          return false;
        })
        .catch(() => false);
      if (openVip) {
        link = `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/pr_index_vip.html#/vip`;
      }
    }
    window.location.replace(link);
  },
};
</script>
